import {
  setLoading,
  setGeneralFormError,
  setOwnerOrSitterFormError,
} from './slice';
import { setUser } from '../Auth/slice';
import axiosInstance from '../../axiosInstance';

export const signup = (data) => async (dispatch) => {
  try {
    dispatch(setLoading(true));
    const { isPetOwner, ...formData } = data;
    const response = await axiosInstance.post('user', formData);
    const { user, token } = response.data.result;
    localStorage.setItem('token', token);
    localStorage.setItem('isPetOwner', isPetOwner);
    dispatch(setUser({ ...user, isPetOwner }));
  } catch (err) {
    if (err?.response?.data) {
      const { error: errorMsg } = err.response.data;
      if (errorMsg.includes('address')) {
        dispatch(setOwnerOrSitterFormError(errorMsg));
      } else {
        dispatch(setGeneralFormError(errorMsg));
      }
    }
  } finally {
    dispatch(setLoading(false));
  }
};
